__turbopack_context__.v({
  "arrowButton": "YU1cdG_arrowButton",
  "arrowButtonLeft": "YU1cdG_arrowButtonLeft",
  "arrowButtonRight": "YU1cdG_arrowButtonRight",
  "pagination": "YU1cdG_pagination",
  "paginationItem": "YU1cdG_paginationItem",
  "slider": "YU1cdG_slider",
  "slides": "YU1cdG_slides",
});
